import React from 'react'
import LockIcon from '@mui/icons-material/Lock'
import { Tooltip } from '@mui/material'
import clsx from 'clsx'
import useUser from '../../hooks/useUser'
import { useLoanLockedContext } from '../../contexts/LoanLockedContext'

export type LoanLockedAlertProps = {
	className?: string
}

const LoanLockedAlert = ({ className }: LoanLockedAlertProps) => {
	const { isLoanAdmin } = useUser()
	const { isLocked } = useLoanLockedContext()

	if (!isLocked || !isLoanAdmin) return null

	return (
		<div className={clsx('text-gray-700', className)} data-cy="root">
			<Tooltip title="The loan is currently in use in Encompass. Loan documents, tasks, and other actions will be queued, and some features may be disabled until user exits the loan.">
				<LockIcon fontSize="medium" />
			</Tooltip>
		</div>
	)
}

export default LoanLockedAlert
